import path from 'path';
import { permission } from 'process';
import JobRequisition from './pages/JobRequisition/JobRequistionList';
import { id } from 'date-fns/locale';

export const summaryPageTopMenu = {
	intro: { id: 'intro', text: 'Intro', path: '#intro', icon: 'Vrpano', subMenu: null },
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap Components',
		path: '#bootstrap',
		icon: 'BootstrapFill',
		subMenu: null,
	},
	storybook: {
		id: 'storybook',
		text: 'Storybook',
		path: '#storybook',
		icon: 'CustomStorybook',
		subMenu: null,
	},
	formik: {
		id: 'formik',
		text: 'Formik',
		path: '#formik',
		icon: 'CheckBox',
		subMenu: null,
	},
	apex: {
		id: 'apex',
		text: 'Apex Charts',
		path: '#apex',
		icon: 'AreaChart',
		subMenu: null,
	},
};
export const logoutMenu = {
	logout: {
		id: 'logout',
		text: 'Logout',
		// path:'auth-page/login',
		path: '/logout',
		icon: 'Logout',
	},
};
export const profileMenu = {
	profile: {
		id: 'profile',
		text: 'Profile',
		icon: 'AccountCircle',
		path: '/profile',
	},
};

export const jobrequisitionMenu = {
	jobListPage: {
		id: 'job-list',
		text: 'Job Template List',
		path: 'job-list',
		icon: 'Description',
	},
	JobRequisition: {
		id: 'jobrequisition',
		text: 'Job Requisition',
		icon: 'assignment',
		path: '/jobRequisition',
	},
	Requirement: {
		id: 'jobrequisition',
		text: 'Requirement',
		icon: 'person_search',
		path: '/Requirement',
	},
};
export const jobRequisitionFormMenu = {
	JobRequisitionForm: {
		id: 'requirementForm',
		text: 'RequirementForm',
		icon: 'Approval',
		path: '/jobRequisition/jobrequisition-form',
	},
};

export const dashboardMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/Dashboard',
		icon: 'Dashboard',
		subMenu: null,
	},
};
export const dashboardPagesMenu = {
	// dashboard: {
	// 	id: 'dashboard',
	// 	text: 'Dashboard',
	// 	path: '/Dashboard',
	// 	icon: 'Dashboard',
	// 	subMenu: null,
	// },
	moduleManage: {
		id: 'listFluid',
		text: 'Module Manage',
		path: 'list-pages/modules',
		icon: 'SpaceDashboard',
	},

	DepartmentManage: {
		id: 'listFluid',
		text: 'Department Manage',
		path: 'list-pages/departments',
		icon: 'CorporateFare',
	},
	role: {
		id: 'role',
		text: 'Role',
		path: 'role',
		icon: 'AdminPanelSettings',
	},
};
export const roleCreationMenu = {
	roleCreate: {
		id: 'rolecreate',
		text: 'Role Create',
		path: 'role/role-create',
		icon: 'personAdd',
	},
	roleUpdate: {
		id: 'roleupdate',
		text: 'Role Update',
		path: `role/role-update/:id`,
		icon: 'personAdd',
	},
};

export const userManagement = {
	user_list: {
		id: 'user_list',
		text: 'User List',
		path: 'user-list',
		icon: 'Group',
	},
};
export const createUser = {
	user: {
		id: 'user',
		text: 'User',
		path: 'user-list/create-user',
		icon: 'personAdd',
	},
	userUpdate: {
		id: 'user',
		text: 'User Update',
		path: 'user-list/update-user/:id',
		icon: 'personAdd',
	},
};

export const interviewPanelMenu = {
	addInterview: {
		id: 'interview',
		text: 'Interview Panel',
		path: 'Requirement/interview-assign',
		icon: 'CameraFront',
	},
};

export const interviewViewMenu = {
	viewInterview: {
		id: 'interviewView',
		text: 'Interview Panel View',
		path: 'jobRequisition/interview-view',
		icon: 'CameraFront',
	},
	feedbackView: {
		id: 'feedbackView',
		text: 'Feedback Form',
		path: 'jobRequisition/feedback-form',
	},
};

export const demoPagesMenu = {
	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: '/',
		icon: 'Login',
	},
	logout: {
		id: 'logout',
		text: 'logout',
		path: '/logout',
		icon: 'PersonRemove',
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
	},
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
};

export const jobDescriptionMenu = {
	job: {
		id: 'job-id',
		text: 'Job Description',
		path: 'job-list/job-template',
		icon: 'bag',
	},
};

export const OfferGenerateMenu = {
	offerGeneratePage: {
		id: 'offer-generate',
		text: 'Offer Generate',
		path: 'offer-list/offer-generate',
		icon: 'TextSnippet',
	},
};
export const OfferListMenu = {
	OfferListPage: {
		id: 'offer-list',
		text: 'Offer List',
		path: 'offer-list',
		icon: 'receipt_long',
	},
	OfferSetting: {
		id: 'offer-setting',
		text: 'Offer setting',
		path: 'offer-setting',
		icon: 'settings_applications',
	},
};

export const FeedbackParameterMenu = {
	FeedBackParameter: {
		id: 'feedback parameter',
		text: 'Feedback',
		path: 'feedbackList/feedbackparameter',
		icon: 'Feedback',
	},
	DetailFeedbackParameter: {
		id: 'detail-feedback-parameter',
		text: 'DetailFeedback',
		path: 'feedbackList/detailfeedbackparameter',
		icon: 'Feedback',
	},
};
export const FeedbackParameterList = {
	FeedBackParameterList: {
		text: 'Feedback ',
		path: 'feedbackList',
		icon: 'rate_review',
	},
};
export const ScheduledInterviewsMenu = {
	ScheduledInterviews: {
		text: 'Interviews',
		path: 'Scheduled-Interviews',
		icon: 'CalendarToday',
	},
};

export const CandidateEvaluationMenu = {
	CandiddateEvaluation: {
		text: 'evaluation ',
		path: 'Scheduled-Interviews/evaluation-feedback',
		icon: 'Person',
	},
};
export const CurrentOpeningsMenu = {
	CurrentOpenings: {
		text: 'Current Openings',
		path: 'current-openings',
		icon: 'work',
	},
};
export const ReferCandidatesList = {
	ReferredCandiates: {
		text: 'Referred Candidates',
		path: 'current-openings/referred-candidates',
		icon: 'Person',
	},
};

export const CandidateApplicationHistory = {
	CandiddateHistory: {
		text: 'Candidate History',
		path: 'CandidateApplicationHistory',
		icon: 'Person',
	},
	CandiddateHistoryTimeLine: {
		text: 'Candidate History',
		path: 'candidate-Application-Details',
		icon: 'Person',
	},
};

export const QuestionariesListMenu = {
	Questionaries: {
		text: 'Questionnaires',
		path: 'Questionnaires',
		icon: 'QuestionAnswer',
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'Page Layout Types',
	},
	blank: {
		id: 'blank',
		text: 'Blank',
		path: 'page-layouts/blank',
		icon: 'check_box_outline_blank ',
	},
	pageLayout: {
		id: 'pageLayout',
		text: 'Page Layout',
		path: 'page-layouts',
		icon: 'BackupTable',
		subMenu: {
			headerAndSubheader: {
				id: 'headerAndSubheader',
				text: 'Header & Subheader',
				path: 'page-layouts/header-and-subheader',
				icon: 'ViewAgenda',
			},
			onlyHeader: {
				id: 'onlyHeader',
				text: 'Only Header',
				path: 'page-layouts/only-header',
				icon: 'ViewStream',
			},
			onlySubheader: {
				id: 'onlySubheader',
				text: 'Only Subheader',
				path: 'page-layouts/only-subheader',
				icon: 'ViewStream',
			},
			onlyContent: {
				id: 'onlyContent',
				text: 'Only Content',
				path: 'page-layouts/only-content',
				icon: 'WebAsset',
			},
		},
	},
	asideTypes: {
		id: 'asideTypes',
		text: 'Aside Types',
		path: 'aside-types',
		icon: 'Vertical Split',
		subMenu: {
			defaultAside: {
				id: 'defaultAside',
				text: 'Default Aside',
				path: 'aside-types/default-aside',
				icon: 'ViewQuilt',
			},
			minimizeAside: {
				id: 'minimizeAside',
				text: 'Minimize Aside',
				path: 'aside-types/minimize-aside',
				icon: 'View Compact',
			},
		},
	},
};

export const AiVoiceInterview = {
	AiVoiceInterview: {
		text: 'AI Voice Interview',
		path: 'ai-voice-interview',
	},
};

export const productsExampleMenu = {
	companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
	// companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
	// companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
	// companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};
